import axios from 'axios'
import { LocalStorage } from '@shared/services/main/storage'
import { PLATFORM_AUTH_STORAGE_KEYS } from './storage'

function normalizeBaseUrl(url) {
  const s = String(url || '').trim()
  const trimmed = s.endsWith('/') ? s.slice(0, -1) : s
  if (trimmed.startsWith('https://') && trimmed.includes('.local')) {
    return `http://${trimmed.slice('https://'.length)}`
  }
  return trimmed
}

export function getPlatformApiBaseUrl() {
  return normalizeBaseUrl(process.env.REACT_APP_PLATFORM_API_BASE_URL)
}

export async function platformLogin({ email_address, password, remember_me }) {
  const base = getPlatformApiBaseUrl()
  if (!base) throw new Error('Missing REACT_APP_PLATFORM_API_BASE_URL')

  const res = await axios.post(
    `${base}/v1/auth/login`,
    { email_address, password, remember_me: remember_me ? 1 : 0 },
    { withCredentials: true }
  )
  return res.data
}

export async function platformRegister(data) {
  const base = getPlatformApiBaseUrl()
  if (!base) throw new Error('Missing REACT_APP_PLATFORM_API_BASE_URL')

  const payload = data && typeof data === 'object' ? data : {}

  const res = await axios.post(
    `${base}/v1/auth/register`,
    payload,
    { withCredentials: true }
  )
  return res.data
}

export async function platformGetCurrentUser() {
  const base = getPlatformApiBaseUrl()
  if (!base) throw new Error('Missing REACT_APP_PLATFORM_API_BASE_URL')

  const apiToken = LocalStorage.get(PLATFORM_AUTH_STORAGE_KEYS.API_TOKEN)

  const res = await axios.get(`${base}/v1/main/auth/user`, {
    withCredentials: true,
    headers: apiToken ? { Authorization: `Bearer ${apiToken}` } : undefined,
  })
  return res.data
}

export async function platformLogout() {
  const base = getPlatformApiBaseUrl()
  if (!base) throw new Error('Missing REACT_APP_PLATFORM_API_BASE_URL')

  const apiToken = LocalStorage.get(PLATFORM_AUTH_STORAGE_KEYS.API_TOKEN)

  const res = await axios.get(`${base}/v1/auth/logout`, {
    withCredentials: true,
    headers: apiToken ? { Authorization: `Bearer ${apiToken}` } : undefined,
  })
  return res.data
}

